import clsx from 'clsx';
import { variationName } from 'utilities/css';

import styles from './SkeletonAction.module.scss';

type Size = 'medium' | 'large';

interface SkeletonActionProps {
  /**
   * Skeleton action size
   * @default 'medium'
   */
  size?: Size;
}

export function SkeletonAction({ size = 'medium' }: SkeletonActionProps) {
  const className = clsx(
    styles.SkeletonAction,
    size && styles[variationName('size', size)],
  );

  return <div className={className}>&nbsp;</div>;
}
